import { Children, createContext, useCallback, useContext, useState } from "react";
import OptionDialog from "../components/Dialog/OptionDialog";


const DialogContext = createContext();

export const DialogProvider = ({ children }) => {

    const [dialog, setDialog] = useState({ open: false });

    const showDialog = useCallback((options) => {
        setDialog({ open: true, ...options });
    }, []);

    const closeDialog = useCallback(() => {
        setDialog((prev) => ({ ...prev, open: false }));
    }, []);

    const handleConfirm = useCallback(() => {
        if (dialog.onConfirm) {
            dialog.onConfirm();
        }
        closeDialog();
    }, [dialog, closeDialog]);



    return (
        <DialogContext.Provider value={showDialog}>
            {children}
            <OptionDialog
                {...dialog}
                open={dialog.open}
                onClose={closeDialog}
                onConfirm={handleConfirm}
            />
        </DialogContext.Provider>
    );
}

export const useDialog = () => useContext(DialogContext);